import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex w-full space-x-4" }
const _hoisted_2 = { class: "flex mt-0 h-full" }
const _hoisted_3 = { class: "flex w-16 h-16 bg-brand-dark-gray my-auto relative rounded-full overflow-hidden" }
const _hoisted_4 = { class: "w-full h-full absolute top-0 left-0 bg-cover bg-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col w-full justify-between text-white border-b border-brand-dark-gray space-y-2" }
const _hoisted_7 = {
  key: 0,
  class: "flex text-xl font-medium my-auto"
}
const _hoisted_8 = {
  key: 1,
  class: "flex text-xl font-medium my-auto"
}
const _hoisted_9 = {
  key: 2,
  class: "flex text-base text-brand-light-gray line-clamp-2 mb-4"
}
const _hoisted_10 = {
  key: 0,
  class: "flex w-full justify-between pb-4 my-auto"
}
const _hoisted_11 = { class: "text-sm text-brand-light-gray line-clamp-2" }
const _hoisted_12 = { class: "text-sm text-white font-medium" }
const _hoisted_13 = { class: "flex flex-col mt-auto space-y-1" }
const _hoisted_14 = { class: "flex mt-auto my-auto text-sm text-brand-light-gray" }
const _hoisted_15 = {
  key: 0,
  class: "ml-auto flex my-auto text-sm text-brand-black w-5 h-5 bg-brand-lime rounded-full"
}
const _hoisted_16 = { class: "m-auto border-transparent text-xs font-semibold" }

import {computed, PropType} from "vue";
import {DateTime} from "luxon";
import {ChatInterface} from "@/interfaces/ChatInterface";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatListItem',
  props: {
    chat: {
        type: Object as PropType<ChatInterface>,
        required: true
    },
    blur: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {


const props = __props

const messageTime = computed(() => {
    const raw = props.chat?.latest_message?.created_at
    if (!raw) return ''
    const dateTime = DateTime.fromISO(String(raw))
    if (!dateTime.isValid) return ''

    // is today
    if (DateTime.now().toISODate() === dateTime.toISODate()) return dateTime.toFormat('HH:mm')

    // is yesterday
    if (DateTime.now().minus({day: 1}).toISODate() === dateTime.toISODate()) return 'Yesterday'

    return dateTime.toFormat('EEE')
})


const isDirectMessage = computed(() => {
    const participants = Array.isArray(props.chat?.participants) ? props.chat.participants : []
    return !participants.find(participant => participant.role === 'ADMIN') && participants.length > 1
})

const dmUser = computed(() => {
    const participants = Array.isArray(props.chat?.participants) ? props.chat.participants : []
    return participants.find(participant => !participant.is_auth_user) || {
        id: 0,
        name: props.chat?.name || 'Chat',
        avatar: props.chat?.image || null,
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "absolute top-0 left-0 w-full h-full object-cover aspect-square",
            onerror: "this.parentNode.removeChild(this)",
            src: isDirectMessage.value ? dmUser.value.avatar : __props.chat.image
          }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col", {
                    'blur-xs' : __props.blur
                }])
      }, [
        (!isDirectMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.chat.name), 1))
          : _createCommentVNode("", true),
        (isDirectMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(dmUser.value.name), 1))
          : _createCommentVNode("", true),
        (!__props.chat.latest_message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "No messages yet, make the first move... "))
          : _createCommentVNode("", true)
      ], 2),
      (__props.chat.latest_message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex w-full flex-col relative", {
                    'blur-xs' : __props.blur
                }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("strong", _hoisted_12, _toDisplayString(__props.chat.latest_message?.posted_by?.is_auth_user ? 'You' : (__props.chat.latest_message?.posted_by?.name || 'Someone')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(__props.chat.latest_message?.original_message || __props.chat.latest_message?.message || ''), 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(messageTime.value), 1),
              (__props.chat.unseen_count)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(__props.chat.unseen_count), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})